import { normalizeUrlPath } from './normalize-path';

/**
 * Sanitizes a redirect path so only same-origin relative paths are allowed
 * (prevents open redirects such as `//evil.com` or `https://evil.com`).
 * @param {unknown} [path] - The raw redirect path (e.g. `reports/home` or `/reports/home?tab=1`).
 * @returns {string} A normalized path starting with `/`, or an empty string if invalid.
 */
export const cleanRedirectPath = (path?: unknown): string => {
  if (!path || typeof path !== 'string') {
    return '';
  }

  const trimmed = path.trim();
  // Reject control characters, absolute URLs, protocol-relative URLs, and backslash tricks
  if (
    // eslint-disable-next-line no-control-regex
    /[\u0000-\u001f\u007f]/.test(trimmed) ||
    /^[a-z][a-z\d+\-.]*:/i.test(trimmed) ||
    trimmed.startsWith('//') ||
    trimmed.includes('\\')
  ) {
    return '';
  }

  const normalized = normalizeUrlPath(trimmed);
  // Prevent loops back to auth routes or bare root
  if (!normalized || normalized === '/' || normalized === '/auth') {
    return '';
  }

  return normalized;
};
